import PageReturnLink from 'crm-links/record/PageReturnLink';
import PortalIdParser from 'PortalIdParser';
import { View } from 'foundations-components/components/View';
import AnimatedBg from './skeleton/AnimatedBg';
import { useCardContextValue } from '../state/CardContext';
import { usageTracker } from '../utils/tracker';
import { useCallback } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const PageReturnLinkComponent = props => {
  return /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
    display: "flex !important"
  }));
};
const BackButtonSkeleton = () => {
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "80px",
    blockSize: "18px",
    borderRadius: "100",
    overflow: "hidden",
    children: /*#__PURE__*/_jsx(AnimatedBg, {})
  });
};
function IndexOrPageReturnLink() {
  var _data$objectTypeDefin, _data$objectTypeDefin2;
  const {
    objectTypeId,
    asyncData: {
      objectTypeDefinitionResult: {
        data,
        loading
      }
    }
  } = useCardContextValue();
  const pluralObjectName = (_data$objectTypeDefin = data === null || data === void 0 || (_data$objectTypeDefin2 = data.objectTypeDefinition) === null || _data$objectTypeDefin2 === void 0 ? void 0 : _data$objectTypeDefin2.pluralForm) !== null && _data$objectTypeDefin !== void 0 ? _data$objectTypeDefin : '';
  const fallbackPagePath = `/contacts/${PortalIdParser.get()}/objects/${objectTypeId}/restore`;
  const logBackLinkClick = useCallback(({
    path
  }) => {
    usageTracker.track('Crm', 'Record Interactions', {
      action: 'navigate back from record page',
      path
    });
  }, []);
  if (loading) {
    return /*#__PURE__*/_jsx(BackButtonSkeleton, {});
  }
  return /*#__PURE__*/_jsx(PageReturnLink, {
    fallbackPageName: pluralObjectName,
    fallbackPagePath: fallbackPagePath,
    onTrackClick: logBackLinkClick,
    LinkComponent: PageReturnLinkComponent
  });
}
export default IndexOrPageReturnLink;